<template>
  <div v-if="products.length > 0" class="homepage-trending">
    <div class="header containerV2">
      <h4>{{ title }}</h4>
      <p>{{ subtitle }}</p>
      <Link v-if="link" class="header__link" :href="link">Shop Now</Link>
    </div>
    <InfiniteCarousel
      :slide-width="slideWidth"
      :slide-width-tablet="slideWidthTablet"
      :slide-width-desktop="slideWidthDesktop"
    >
      <div v-for="(product, index) in products" :key="product.id">
        <ProductCardHelper
          v-slot="{ primaryMedia }"
          :product="product"
          :image-type="getImageType(index)"
        >
          <ProductCard
            :media="primaryMedia"
            :product="product"
            text-alignment="center"
            hover-text="Shop Now"
          />
        </ProductCardHelper>
      </div>
    </InfiniteCarousel>
  </div>
</template>

<script>
import InfiniteCarousel from "@/components/InfiniteCarousel.vue";
import ProductCard from "@/components/ProductCard.vue";
import ProductCardHelper from "@/components/product-card/ProductCardHelper.vue";
import { indexFeaturedProductsSequence } from "@/helpers/imageSequences.js";
import Link from "@/components/Link.vue";

export default {
  name: "HomepageNosto",
  components: {
    InfiniteCarousel,
    ProductCard,
    ProductCardHelper,
    Link,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      default: null,
    },
    slideWidth: {
      type: String,
      default: "200px",
    },
    slideWidthTablet: {
      type: String,
      default: "260px",
    },
    slideWidthDesktop: {
      type: String,
      default: "300px",
    },
    imageSequence: {
      type: Array,
      default: () => indexFeaturedProductsSequence,
    },
  },
  methods: {
    getImageType(index) {
      return this.imageSequence[index % this.imageSequence.length];
    },
  },
};
</script>

<style lang="scss" scoped>
.homepage-trending {
  padding: 40px 0 60px;
}

.header {
  margin: 0 auto;
  text-align: center;
  margin-bottom: 40px;

  h4 {
    @include editorial-headline(24px);
    text-transform: uppercase;
    margin-bottom: 16px;
  }

  p {
    @include editorial-body(14px);
    text-wrap: balance;
  }

  &__link {
    margin-top: 20px;
  }
}
</style>
